__turbopack_context__.v({
  "description": "section-header-module-scss-module__ilelja__description",
  "hint": "section-header-module-scss-module__ilelja__hint",
  "iconWrapper": "section-header-module-scss-module__ilelja__iconWrapper",
  "mainContentWrapper": "section-header-module-scss-module__ilelja__mainContentWrapper",
  "sectionHeaderWrapper": "section-header-module-scss-module__ilelja__sectionHeaderWrapper",
  "textWrapper": "section-header-module-scss-module__ilelja__textWrapper",
  "titleWrapper": "section-header-module-scss-module__ilelja__titleWrapper",
  "topActionWrapper": "section-header-module-scss-module__ilelja__topActionWrapper",
  "withoutDescription": "section-header-module-scss-module__ilelja__withoutDescription",
});
